<template>
  <div id="adjustment">
    <div class="header flex-between">
      <div class="header-text">
        <h1>会员级别调整</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="iconfont icon-sousuo1"
          @click="searchBtn"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="iconfont icon-chuangjian1"
          @click="creatbtn"
          >创建</el-button
        >
        <el-button
          v-if="jurisdiction.Import"
          icon="iconfont icon-daoru1"
          @click="MemberFreezeImport = true"
          >导入</el-button
        >
        <el-button
          v-if="jurisdiction.Import"
          icon="el-icon-download"
          @click="(downloadShow = true), getDownladList()"
          >下载导入结果</el-button
        >
      </div>
    </div>
    <!-- 创建弹窗 -->
    <div class="found">
      <el-dialog
        width="40%"
        title="会员级别调整-创建"
        :visible.sync="foundFormVisible"
        :close-on-click-modal="false"
        @close="resetForm"
      >
        <el-form
          size="mini"
          label-width="100px"
          :model="formLabeladd"
          ref="resberValidateForm"
          :rules="rules"
        >
          <el-row :gutter="30">
            <el-col :span="24" style="margin-top: 20px">
              <el-form-item label="会员卡号" prop="cardNo">
                <el-input
                  v-model="formLabeladd.cardNo"
                  :disabled="true"
                  style="width: 70%"
                ></el-input>
                <el-button @click="xuanzhebtn" style="margin-left: 20px"
                  >选择会员</el-button
                >
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="会员姓名">
                <el-input
                  placeholder=""
                  v-model="formLabeladd.custName"
                  :disabled="true"
                  style="width: 70%"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :span="24">
              <el-form-item label="会员调整前消费等级">
                <el-input
                  v-model="formLabeladd.levelName"
                  :disabled="true"
                  style="width: 70%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="会员调整后消费等级" prop="newLevel">
                <el-select style="width: 70%" v-model="formLabeladd.newLevel">
                  <el-option
                    v-for="item in vipcut"
                    :key="item.levelID"
                    :value="item.levelID"
                    :label="item.levelName_cn"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :span="24">
              <el-form-item label="变更原因" prop="reasonID">
                <el-select
                  style="width: 70%"
                  v-model="formLabeladd.reasonID"
                  @change="myback"
                >
                  <el-option
                    v-for="item in Xercuter"
                    :key="item.reasonID"
                    :value="item.reasonID"
                    :label="item.reason_CN"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="其他原因备注" prop="otherReason">
                <el-input
                  v-model="formLabeladd.otherReason"
                  :disabled="disadbycool"
                  style="width: 70%"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :span="24">
              <el-form-item label="实际变更日期" prop="realChgDate">
                <el-date-picker
                  v-model="formLabeladd.realChgDate"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  style="width: 70%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="调整说明" prop="remark">
                <el-input
                  type="textarea"
                  style="margin-bottom: 20px; width: 70%"
                  v-model="formLabeladd.remark"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="createAdjust('resberValidateForm')"
            >确 定</el-button
          >
          <el-button @click="Splicest">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <el-card shadow="never">
      <div class="searchform">
        <el-form label-width="200px" :model="queryInfo" size="mini">
          <el-row>
            <el-col :span="8">
              <el-form-item label="会员卡号\会员姓名\手机号">
                <el-input v-model="queryInfo.search"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所属区域">
                <el-select
                  style="width: 100%"
                  v-model="queryInfo.regionID"
                  @change="changeSelectes"
                >
                  <el-option value="" label="全部"></el-option>
                  <el-option
                    v-for="item in areaOptions"
                    :key="item.id"
                    :value="item.id"
                    :label="item.lable"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所属门店">
                <el-select style="width: 100%" v-model="queryInfo.serviceOrgID">
                  <el-option value="" label="全部"></el-option>
                  <el-option
                    v-for="item in shopLists"
                    :key="item.id"
                    :value="item.id"
                    :label="item.lable"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" style="margin-top: -25px">
              <el-form-item label="调整时期从" style="margin-top: 30px">
                <el-date-picker
                  v-model="queryInfo.startChgDate"
                  type="date"
                  placeholder="开始日期"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="margin-top: -25px">
              <el-form-item label="至" style="margin-top: 30px">
                <el-date-picker
                  v-model="queryInfo.endChgDate"
                  type="date"
                  placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div class="centercard">
      <el-card shadow="never">
        <el-table
          size="small"
          class="table-style"
          height="580px"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            color: '#6C6839',
            'text-align': 'center',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          v-loading="loadsing"
          v-el-table-infinite-scroll="loadcust"
          infinite-scroll-disabled="onLoadlook"
        >
          <el-table-column width="40">
            <template slot-scope="scope">
              <el-radio
                v-model="radio"
                :label="scope.$index"
                @change.native="handleRadioChange(scope.row)"
                >&nbsp;</el-radio
              >
            </template>
          </el-table-column>
          <el-table-column prop="sheetNo" label="单据号"> </el-table-column>
          <el-table-column prop="custName" label="会员姓名"></el-table-column>
          <el-table-column prop="cardNo" label="会员卡号"> </el-table-column>
          <el-table-column prop="origLevelName" label="调整前会员等级">
          </el-table-column>
          <el-table-column prop="newLevelName" label="调整后会员等级">
          </el-table-column>
          <el-table-column prop="regionName" label="所属区域">
          </el-table-column>
          <el-table-column prop="shopAlias" label="所属门店"> </el-table-column>
          <el-table-column prop="realChgDate" label="调整日期">
            <template slot-scope="scope">
              {{ scope.row.realChgDate | dateFormats }}
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="移动电话"> </el-table-column>
          <el-table-column prop="custTypeText" label="会员类型">
          </el-table-column>
          <el-table-column
            prop="createUserName"
            label="创建人"
          ></el-table-column>
          <el-table-column prop="createTime" label="创建日期">
            <template slot-scope="scope">
              {{ scope.row.createTime | dateFormats }}
            </template>
          </el-table-column>
        </el-table>
        <el-alert
          v-if="isMoree"
          title="没有更多啦!"
          type="warning"
          center
          show-icon
        >
        </el-alert>
      </el-card>
    </div>

    <!-- 选择会员弹窗 -->
    <div class="fittin">
      <el-dialog
        width="50%"
        title="顾客维护记录—创建—选择会员"
        :visible.sync="basculemovement"
        :close-on-click-modal="false"
      >
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="会员卡号\会员姓名\手机号">
            <el-input placeholder="" v-model="searchFormily.search"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button icon="iconfont icon-sousuo1" @click="Searchbtn"
              >查询</el-button
            >
          </el-form-item>
        </el-form>

        <el-table
          class="table-style"
          border
          size="small"
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            color: '#6C6839',
            'text-align': 'center',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          tooltip-effect="dark"
          :data="newArr"
          v-loading="loading"
          v-el-table-infinite-scroll="loadapi"
          infinite-scroll-disabled="onLoading"
        >
          <el-table-column width="40">
            <template slot-scope="scope">
              <el-radio
                :label="scope.$index"
                v-model="radiovip"
                @change.native="Clickradio(scope.row)"
                >&nbsp;
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="cardNo" label="会员卡号"> </el-table-column>
          <el-table-column prop="custName" label="会员姓名"> </el-table-column>
          <el-table-column prop="mobile" label="手机号"> </el-table-column>
          <el-table-column prop="levelName" label="消费等级"></el-table-column>
          <el-table-column prop="regionName" label="所属区域">
          </el-table-column>
          <!-- <el-table-column prop="state" label="预约状态"> </el-table-column> -->
          <!-- 预约状态设置 -->
          <el-table-column label="所属门店" prop="shopName" width="180">
          </el-table-column>
          <el-table-column prop="serviceEmpName" label="维护品牌顾问">
          </el-table-column>
        </el-table>
        <el-alert
          v-if="isMore"
          title="没有更多数据了!"
          type="warning"
          center
          :closable="false"
        >
        </el-alert>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Resfitting">确定</el-button>
          <el-button @click="Exception">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 导入保存确认对话框 -->
    <div class="import">
      <el-dialog
        title="会员消费等级—会员消费等级调整-导入"
        :visible.sync="MemberFreezeImport"
        :close-on-click-modal="false"
        width="40%"
      >
        <el-form
          size="mini"
          label-width="225px"
          ref="newUploadForm"
          enctype="multipart/form-data"
        >
          <el-form-item label="选择待导入会员消费等级冻结文件">
            <div class="flex-start">
              <el-input
                style="width: 300px"
                v-model="filename"
                :readonly="true"
                placeholder="请选择文件名"
              >
              </el-input>
              <el-upload
                class="upload"
                action="#"
                :show-file-list="false"
                :on-change="handleExcel"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                :auto-upload="false"
              >
                <el-button style="margin-left: 20px">选择文件</el-button>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button icon="el-icon-download" @click="Xiazaimukuai"
            >下载模板</el-button
          >
        </span>
      </el-dialog>

      <!-- 下载弹窗 -->
      <el-dialog
        append-to-body
        width="50%"
        :visible.sync="downloadShow"
        title="下载导入结果"
      >
        <el-table
          size="small"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="downloadData"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <!-- v-loading="loading"
        v-el-table-infinite-scroll="load"
        infinite-scroll-disabled="onLoading" -->
          <el-table-column
            type="index"
            width="55"
            label="序号"
          ></el-table-column>
          <el-table-column
            prop="startTime"
            label="导入开始时间"
          ></el-table-column>

          <el-table-column
            prop="endTime"
            label="导入结束时间"
          ></el-table-column>

          <el-table-column prop="isComplate" label="状态">
            <template slot-scope="scope">
              {{ scope.row.isComplate ? "完成" : "执行中" }}
            </template>
          </el-table-column>
          <el-table-column prop="startTime" label="下载">
            <template slot-scope="scope">
              <el-button
                icon="el-icon-download"
                v-if="scope.row.isComplate"
                @click="download(scope.row.downloadUrl)"
                >下载</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="downloadShow = false">取消</el-button>
        </div>
      </el-dialog>
      <!-- 会员消费等级—会员消费等级调整-导入下载弹窗 -->
      <!-- <div class="import">
        <el-dialog title="会员消费等级—会员消费等级调整-导入"
                   :visible.sync="defaultisderived"
                   :close-on-click-modal="false"
                   width="40%">
          <div class="resui">
            <span>成功处理行数: {{ succeedInfo.sucNum }}</span>
            <span>失败处理行数: {{ succeedInfo.errNum }}</span>
            <span>处理结果文件:
              <a :href="succeedInfo.fileUrl">{{ succeedInfo.fileUrl }} </a>
              <el-button icon="el-icon-download"
                         @click="downfile(succeedInfo.fileUrl)"
                         style="margin-left: 10px">下载</el-button>
            </span>
          </div>
        </el-dialog>
      </div> -->
    </div>
  </div>
</template>
<script>
import { getcpyNo } from "@/utils/auth";
import { reportFormList } from "@/api/reportForm";
import { queryRegionApi, shopSelectByCodeApi } from "@/api/shop";
import {
  RequestPageApi,
  custInsertApi,
  queryLSelectApi,
  queryLOptionApi,
  upExlsx,
} from "@/api/user";
import { Usermembers } from "@/api/huiyuanyy";
export default {
  name: "centre",
  data() {
    return {
      downloadData: [],
      downloadShow: false,
      succeedInfo: {},
      radio: "",
      foundFormVisible: false,
      basculemovement: false,
      MemberFreezeImport: false,
      // defaultisderived: false,
      labelPosition2: "top",
      loading: false,
      count: 1,
      //导入信息

      filename: "", //创建
      formLabeladd: {
        chgReasonID: "", //变更原因
        custID: "", //客户ID
        newLevel: "", //新级别
        origLevel: "", //原始级别
        otherReason: "", //其他原因
        realChgDate: "", //实际变更日期
        remark: "", //调整说明
        custName: "", //会员姓名
        levelName: "", //原先等级
        // sheetNo: "123",
        cardNo: "",
        reasonID: "",
      },
      rules: {
        cardNo: [
          {
            required: true,
            message: "请选择会员卡号",
            trigger: "change",
          },
        ],
        newLevel: [
          {
            required: true,
            message: "请选择会员调整后的级别",
            trigger: "change",
          },
        ],
        realChgDate: [
          {
            required: true,
            message: "请选择实际变更日期",
            trigger: "change",
          },
        ],
        reasonID: [
          {
            required: true,
            message: "请选择变更原因",
            trigger: "change",
          },
        ],
      },
      //选择会员search
      searchFormily: {
        search: "",
        pageNo: 1,
        pageSize: 10,
      },
      //创建原因变更选项
      whytyper: {
        pageNo: 1,
        pageSize: 10,
        reasonKind: 100,
      },
      Xercuter: [],
      areaOptions: [], // 区域options
      areaValue: "",
      storesOptions: [], // 门店options
      storesValue: "",
      queryInfo: {
        pageNo: 1,
        pageSize: 50,
        regionID: "", //地区
        search: "",
        serviceOrgID: "", //门店
        startChgDate: "",
        endChgDate: "",
        pages: 0,
      },
      changeRadioValue: [],
      pageNum: 1,
      size: 0,
      total: 0,
      radiovip: "",
      tableData: [],
      newArr: [], //存放选择会员消息
      tempsell: [], //存放 选着会员选中的值
      vipcut: [], //存放会员等级信息
      loadsing: false,
      disadbycool: true,
      //门店
      shopLists: [],
      jurisdiction: {
        search: false,
        create: false,
        Import: false,
      },
    };
  },
  created() {
    this.levelList();
    this.areaList();
    this.shopList();
    let Adjustment = JSON.parse(localStorage.getItem("Adjustment"));
    console.log(Adjustment);
    for (let i = 0; i < Adjustment.length; i++) {
      if (Adjustment[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Adjustment[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }

      if (Adjustment[i].menuName == "导入") {
        this.jurisdiction.Import = true;
        continue;
      }
    }

    // this.createAdjust()
  },
  computed: {
    isMore() {
      return this.count >= this.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
    isMoree() {
      //当起始页数等于总页数时停止加载
      return this.queryInfo.pageNo >= this.queryInfo.pages;
    },
    onLoadlook() {
      return this.loadsing || this.isMoree;
    },
  },
  methods: {
    // 默认日期
    moren() {
      const jinri = new Date();
      this.formLabeladd.realChgDate = jinri;
    },
    //获取下载列表数据
    getDownladList() {
      reportFormList({
        groupName: "会员级别调整导入",
      }).then((response) => {
        console.log(response);
        this.downloadData = response.data;
      });
    },
    download(src) {
      this.exportShow = false;
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = process.env.VUE_APP_BASE_API  + src;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    downfile(url) {
      // console.log(url, '*****');
      const ele = document.createElement("a");
      ele.style.display = "none";
      // 设置href属性为文件路径，download属性可以设置文件名称
      ele.href = process.env.VUE_APP_BASE_API + url;
      ele.download = "";
      // 将a标签添加到页面并模拟点击
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      // 移除a标签
      ele.remove();
    },
    handleExcel(file) {
      // console.log(file);
      let formData = new FormData(); //声明一个FormDate对象
      formData.append("file", file.raw); //把文件信息放入对象中
      // console.log(formData.get("file"));
      //调用后台导入的接口
      upExlsx(formData)
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            this.levelList(); // 导入表格之后可以获取导入的数据渲染到页面，此处的方法是获取导入的数据
          } else {
            this.$message.success("导入成功请在下载列表查看");
            // this.defaultisderived = true;
            this.succeedInfo = res.data;
            this.MemberFreezeImport = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "导入失败",
          });
        });
    },

    //下载模板功能
    Xiazaimukuai() {
      const ele = document.createElement("a");
      ele.style.display = "none";
      // 设置href属性为文件路径，download属性可以设置文件名称
      ele.href =
        process.env.VUE_APP_BASE_API +
        "/api/templates/会员级别调整导入模板.xlsx";
      ele.download = "";
      // 将a标签添加到页面并模拟点击
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      // 移除a标签
      ele.remove();
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    //改变时显示在input框
    handleChange(file) {
      this.filename = file.name;
    },
    // table列表
    async levelList() {
      const { data: res } = await RequestPageApi(this.queryInfo);
      res.list.map((item) => {
        item.custTypeText =
          item.custType == 0
            ? "非VIC会员"
            : item.custType == 1
            ? "VIC会员"
            : "";
      });
      if (this.queryInfo.pageNo == 1) this.tableData = [];
      this.tableData = this.tableData.concat(res.list);
      this.size = res.size;
      this.total = res.total;
      this.queryInfo.pages = res.pages;
      this.loadsing = false;
    },
    handleRadioChange(val) {
      this.changeRadioValue = val;
    },
    //选择会员弹框滚动加载
    loadapi() {
      this.loading = true;
      setTimeout(() => {
        this.count += 1;
        this.dataList();
      }, 1000);
    },
    dataList() {
      Usermembers({
        pageNo: this.count,
        pageSize: "10",
      }).then((res) => {
        this.newArr = this.newArr.concat(res.data.list);
        this.pages = res.data.pages;
        this.loading = false;
      });
    },
    // 条件查询
    searchBtn() {
      this.queryInfo.pageNo = 1;
      this.levelList();
    },
    // 区域
    async areaList() {
      const { data: res } = await queryRegionApi({
        cpyNO: getcpyNo(),
      });
      this.areaOptions = res;
      // console.log(this.areaOptions);
    },
    // 门店
    async shopList() {
      const { data: res } = await shopSelectByCodeApi({
        shopCode: "",
      });
      this.storesOptions = res;
    },
    //点击创建显示弹窗
    creatbtn() {
      this.moren();
      this.foundFormVisible = true;
      // this.UsernameKy();
      this.VipqueryLSelectApi();
      this.queryLOptioncut();
    },
    // 创建保存
    async createAdjust() {
      let arr = {
        chgReasonID: this.formLabeladd.reasonID, //变更原因
        custID: this.formLabeladd.custID, //客户ID
        newLevel: this.formLabeladd.newLevel, //新级别
        origLevel: this.formLabeladd.origLevel, //原始级别
        otherReason: this.formLabeladd.otherReason, //其他原因
        realChgDate: this.formLabeladd.realChgDate, //实际变更日期
        remark: this.formLabeladd.remark, //调整说明
        custName: this.formLabeladd.custName, //会员姓名
        levelName: this.formLabeladd.levelName, //原先等级
        // sheetNo: "123",
        cardNo: this.formLabeladd.cardNo,
      };
      this.$refs.resberValidateForm.validate(async (valid) => {
        if (!valid) return;
        if (!this.disadbycool && this.formLabeladd.otherReason == "") {
          this.$message.warning("请填写其他原因备注！");
        } else {
          await custInsertApi(arr).then((res) => {
            if (res.message == "success") {
              this.$message.success("创建成功!");
              //关闭对话框
              this.formLabeladd = {};
              this.formLabeladd.otherReason = "";
              this.foundFormVisible = false;
              //重新获取初始化数据
              this.levelList();
            }
          });
        }
      });
      // const res = await custInsertApi(this.formLabeladd)
      // console.log(res);
    },
    // 会员等级下拉框数据
    async VipqueryLSelectApi() {
      const res = await queryLSelectApi();
      this.vipcut = res.data;
    },
    //变更原因数据
    async queryLOptioncut() {
      const res = await queryLOptionApi(this.whytyper);
      this.Xercuter = res.data;
    },
    // //监听resetForm
    resetForm() {
      this.$refs.resberValidateForm.resetFields();
      this.formLabeladd = {};
    },
    //取消按钮消除校验
    Splicest() {
      this.$refs.resberValidateForm.resetFields();
      this.formLabeladd = {};
      this.foundFormVisible = false;
    },
    //选择会员开关按钮
    xuanzhebtn() {
      this.basculemovement = true;
    },
    //获取会员选择消息
    async UsernameKy() {
      const res = await Usermembers(this.searchFormily);
      this.newArr = res.data.list;
    },
    //赋值radio
    Clickradio(row) {
      this.tempsell = row;
    },
    // 选择会员确认按钮
    Resfitting() {
      this.formLabeladd.custID = this.tempsell.custID;
      this.formLabeladd.custName = this.tempsell.custName;
      this.formLabeladd.origLevel = this.tempsell.levelID;
      this.formLabeladd.levelName = this.tempsell.levelName;
      this.formLabeladd.cardNo = this.tempsell.cardNo;
      this.radiovip = "";
      this.basculemovement = false;
    },
    // 选择会员取消按钮
    Exception() {
      this.basculemovement = false;
    },

    //选择会员查询按钮
    Searchbtn() {
      this.UsernameKy();
    },
    //外层表格数据滚动加载
    loadcust() {
      this.loadsing = true;
      setTimeout(() => {
        this.queryInfo.pageNo += 1;
        this.levelList();
      }, 1000);
    },
    myback() {
      this.Xercuter.forEach((item) => {
        if (item.reasonID === this.formLabeladd.reasonID) {
          this.disadbycool = !item.isNeedOtherReason;
        }
      });
    },
    changeSelectes() {
      for (let k in this.areaOptions) {
        if (this.queryInfo.regionID === this.areaOptions[k].id) {
          this.shopLists = this.areaOptions[k].chlidren;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__footer {
  height: 60px;
  background-color: #f2f2f2;
}
#adjustment {
  // height: 1300px;
  height: 100%;
}
.header-text {
  height: 30px;
  margin-top: 10px;
  color: #76734f;
}
.searchform {
  margin-top: 10px;
}
.centercard {
  margin-top: 10px;
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

.el-table .warning-row {
  background: #fcfbf2;
}

.el-table .success-row {
  background: #ffffff;
}
::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
}
::v-deep {
  // 卡号变更弹框样式
  .found {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 0 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .fittin {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__body {
      padding: 10px 20px;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  // 冻结弹窗样式
  .import {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 10px 30px 20px 30px;
    }
    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }

    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .resui {
    display: flex;
    flex-direction: column;
  }
  .resui span {
    line-height: 30px;
    font-size: 18px;
  }
}
</style>
